import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { ParagraphBold } from "@/components/ui/typography/ParagraphBold";
import { ChangePasswordForm } from "@/components/profile/change-password/ChangePasswordForm";

import passwordImg from "@/assets/reset-password/new-password.svg";

export const Route = createFileRoute("/dashboard/profile/change-password/")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: ChangePassword,
});

function ChangePassword() {
  const { t } = useTranslation();

  return (
    <div className="mb-8 max-w-7xl mx-auto">
      <SectionRoute
        route_one={t("routes.dashboard")}
        route_two={t("routes.profile")}
        route_two_link="/dashboard/profile"
        route_three={t("routes.change_password")}
      />
      <section className="grid md:grid-cols-1 md:gap-8 xl:grid-cols-5 content-center md:min-h-[400px] xl:min-h-[550px] 2xl:min-h-[650px]">
        {/* Form */}
        <div className="xl:col-span-3 flex flex-col gap-4 xl:max-w-4/5 self-center">
          <HeadingOne>{t("profile.change_password.title")}</HeadingOne>
          <ChangePasswordForm />
        </div>
        {/* Rules */}
        <div className="xl:col-span-2 flex flex-col gap-4 xl:justify-center xl:items-center">
          <img
            src={passwordImg}
            alt=""
            className="hidden xl:block w-[200px] 2xl:w-[300px] h-auto self-start"
          />
          <ParagraphBold>{t("password_requirements.title")}</ParagraphBold>
          <ul className="list-disc ml-10 mb-12 xl:mb-0">
            <li>{t("password_requirements.min_length")}</li>
            <li>{t("password_requirements.max_length")}</li>
            <li>{t("password_requirements.uppercase")}</li>
            <li>{t("password_requirements.number")}</li>
            <li>{t("password_requirements.special_character")}</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
